<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";

export default {
  name: "VehicleListingsBestMatches",
  extends: VehicleListingsBase,
  skipVehicleListingsAutoFetch: true, // We handle fetching ourselves after setting up sorting
  mounted() {
    // this.innerFilters = [{ "time_created": { gte: Math.floor((Date.now() - 168 * 60 * 60 * 1000) / 1000) } }];
    // this.innerFilters = [{ "_score": { "gte": 0 }}];
    this.innerSorting = [{ _score: "desc" }];
    this.getVehicles();
  }
};
</script>
